import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import clsx from 'clsx';

import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import * as ConversionActions from '../../../actions/conversionActions';

import * as classes from './DetailsPanel.module.css';

const DetailsPanel = ({
    customConversions,
    k2aConversions,
    selectedConversion,
    setNewConversion,
    setSelectedConversion,
    ...props
}) => {
    const [companyConversionsOpen, setCompanyConversionsOpen] = useState(false);
    const [k2aConversionsOpen, setK2aConversionOpen] = useState(false);
    const [search, setSearch] = useState('');

    const [filteredCustomConversions, setFilteredCustomConversions] = useState([]);
    const [filteredK2aConversions,setFilteredK2aConversions] = useState([]);

    useEffect(() => {
        setFilteredCustomConversions(customConversions);
        setFilteredK2aConversions(k2aConversions);
    }, [customConversions, k2aConversions]);

    const handleOpenCompanyConversions = () => {
        setCompanyConversionsOpen(!companyConversionsOpen);
    };

    const handleOpenK2aConversions = () => {
        setK2aConversionOpen(!k2aConversionsOpen);
    };

    const handleSearch = event => {
        const { value } = event.target;
        setSearch(value);

        if (value) {
            const filteredCustom = customConversions.filter(item => item.name.toLowerCase().includes(value.toLowerCase()));
            const filteredK2a = k2aConversions.filter(item => item.name.toLowerCase().includes(value.toLowerCase()));

            setFilteredCustomConversions(filteredCustom);
            setFilteredK2aConversions(filteredK2a);
        } else {
            setFilteredCustomConversions(customConversions);
            setFilteredK2aConversions(k2aConversions);
        }
    };

    const handleAddNewConversion = () => {
        setNewConversion(true);
        setSelectedConversion({});
    };

    return (
        <div>
            <div className={classes.Header}>
                <span className={classes.Title}>Details</span>
                <span className={classes.ButtonContainer}>
                    <div role="none" onClick={() => handleAddNewConversion()} className={classes.AddContainerButton}>
                        <span className={clsx('material-icons-outlined', classes.AddButton)}>
                            add
                        </span>
                        <div className={classes.AddText}>New Conversion</div>
                    </div>
                </span>
            </div>
            <div>
                <div className={classes.SearchContainer}>
                    <span className={clsx('material-icons-outlined md-18', classes.SearchBar)}>
                        search
                    </span>
                    <TextField
                        onChange={handleSearch}
                        value={search}
                        className={classes.TextField}
                        id="input-with-icon-textfield"
                        placeholder="Search by keyword"
                        InputProps={{
                            style:            { fontSize: '1.4rem' },
                            disableUnderline: true
                        }}
                        InputLabelProps={{
                            style: { fontSize: '1.4rem', color: '#c6c6c6' },
                        }}
                    />
                </div>
            </div>
            <div>
                <List className={classes.ListTitle}>
                    <ListItem
                        className={classes.ListMenu}
                        key={0}
                        onClick={() => handleOpenCompanyConversions()}
                    >
                        <span className={clsx('material-icons-outlined', classes.ArrowIcon)}>
                            {
                                companyConversionsOpen ?
                                    'expand_more'
                                    :
                                    'chevron_right'
                            }
                        </span>
                        Company Conversions
                    </ListItem>
                    {
                        companyConversionsOpen ?
                            <div>
                                <List>
                                    {filteredCustomConversions.map((item, index) => (
                                        <ListItem
                                            className={selectedConversion.id === item.id ? classes.SelectedListItem : classes.ListItem}
                                            key={index}
                                            onClick={() => setSelectedConversion(item)}
                                        >
                                            {item.name}
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                            :
                            null
                    }
                </List>
            </div>
            <div>
                <List className={classes.ListTitle}>
                    <ListItem
                        className={classes.ListMenu}
                        key={0}
                        onClick={() => handleOpenK2aConversions()}
                    >
                        <span className={clsx('material-icons-outlined', classes.ArrowIcon)}>
                            {
                                k2aConversionsOpen ?
                                    'expand_more'
                                    :
                                    'chevron_right'
                            }
                        </span>
                        K2A Conversions
                    </ListItem>
                    {
                        k2aConversionsOpen ?
                            <div>
                                <List>
                                    {filteredK2aConversions.map((item, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={() => setSelectedConversion(item)}
                                            className={selectedConversion.id === item.id ? classes.SelectedListItem : classes.ListItem}
                                        >
                                            {item.name}
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                            :
                            null
                    }
                </List>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        customConversions:  state.conversion.customConversions,
        k2aConversions:     state.conversion.k2aConversions,
        selectedConversion: state.conversion.selectedConversion
    };
};

const mapDispatchToProps = {
    ...ConversionActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsPanel);
